/**
 * @format
 */

import { Edit, Visibility } from '@mui/icons-material';
import {
  Box,
  Chip,
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material';

function ListRoles({ roles, options, handleActiveRole }) {
  // list of roles, edit and view for each items
  if (!roles?.length) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography sx={{ color: 'rgba(255, 255, 255, 0.7)' }}>
          No roles found.
        </Typography>
      </Box>
    );
  }

  return (
    <TableContainer
      component={Box}
      sx={{
        width: '90%',
        // maxWidth: 550,
        mx: 'auto',
        mt: 2.5,
        p: 2.5,
        borderRadius: 4,
        display: 'flex',
        flexDirection: 'column',
        background:
          'linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%)',
        backdropFilter: 'blur(12px)',
        border: '1px solid rgba(255, 255, 255, 0.15)',
        boxShadow: '0 10px 30px rgba(0,0,0,0.5)',
        color: 'white',
        boxSizing: 'border-box',
      }}
    >
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell sx={{ color: 'white', fontWeight: 600 }}>
              Job Titles
            </TableCell>
            <TableCell sx={{ color: 'white', fontWeight: 600 }}>
              Modules
            </TableCell>
            <TableCell align="center" sx={{ color: 'white', fontWeight: 600 }}>
              Permissions
            </TableCell>
            <TableCell align="right" sx={{ color: 'white', fontWeight: 600 }}>
              Actions
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {options?.modules?.length &&
            options?.jobTitles?.length &&
            roles.map((role) => {
              const { modules, jobTitles } = options;
              const { jobTitleId, moduleOperationId } = role;
              const jobTitleIds = Array.isArray(jobTitleId)
                ? jobTitleId
                : [jobTitleId];
              const moduleOperationIds = Array.isArray(moduleOperationId)
                ? moduleOperationId
                : [moduleOperationId];
              return (
                <TableRow
                  key={role.JobTitleToModuleOperationId}
                  sx={{
                    '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.05)' },
                  }}
                >
                  <TableCell sx={{ color: 'white' }}>
                    <Stack
                      direction="row"
                      spacing={0.5}
                      flexWrap="wrap"
                      useFlexGap
                    >
                      {jobTitleIds.map((jt) => {
                        const job = jobTitles.find(
                          (j) => Number(j.jobTitleId) === Number(jt)
                        );
                        return (
                          <Chip
                            key={jt}
                            label={job?.jobTitleName}
                            size="small"
                            sx={{
                              color: 'white',
                              borderColor: 'rgba(255, 255, 255, 0.4)',
                            }}
                          />
                        );
                      })}
                    </Stack>
                  </TableCell>
                  <TableCell sx={{ color: 'white' }}>
                    <Stack
                      direction="row"
                      spacing={0.5}
                      flexWrap="wrap"
                      useFlexGap
                    >
                      {moduleOperationIds.map((m) => {
                        const module = modules.find(
                          (mx) => Number(mx.moduleOperationId) === Number(m)
                        );
                        return (
                          <Chip
                            key={m}
                            label={module?.moduleOperationName}
                            size="small"
                            variant="outlined"
                            sx={{
                              color: 'white',
                              borderColor: 'rgba(255, 255, 255, 0.4)',
                            }}
                          />
                        );
                      })}
                    </Stack>
                  </TableCell>
                  <TableCell align="center" sx={{ color: 'white' }}>
                    <Tooltip title={role.view ? 'Can view' : 'Cannot view'}>
                      <Visibility
                        fontSize="small"
                        sx={{
                          color: 'white',
                          opacity: role.view ? 1 : 0.3,
                          mr: 1,
                        }}
                      />
                    </Tooltip>
                    <Tooltip title={role.edit ? 'Can edit' : 'Cannot edit'}>
                      <Edit
                        fontSize="small"
                        sx={{
                          color: 'white',
                          opacity: role.edit ? 1 : 0.3,
                        }}
                      />
                    </Tooltip>
                  </TableCell>
                  <TableCell align="right" sx={{ color: 'white' }}>
                    <Tooltip title="Edit role">
                      <Typography
                        onClick={() => handleActiveRole(role)}
                        sx={{ fontSize: '11px', cursor: 'pointer' }}
                      >
                        Update
                      </Typography>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              );
            })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default ListRoles;
